import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { CFBaseListItemHelpers, CFBaseListItemTokens } from './styles';
export const CFBaseListItemStyles = {
    Accessory: css `
    display: flex;
    flex-direction: row;
    gap: ${CFTokens.SPACER.D}px;
  `,
    Divider: css `
    position: absolute;
    ${CFBaseListItemHelpers.dividerPosition}
  `,
    Dot: css `
    box-sizing: border-box;
    margin-top: -${CFBaseListItemTokens.DOT_SIZE / 2}px;
    position: absolute;
    ${CFBaseListItemHelpers.dotPosition};
  `,
    Root: css `
    box-sizing: border-box;
    padding: 0;
    display: flex;
    gap: 0;
    flex-direction: column;
    position: relative;
  `,
    RootNative: css `
    ${CFBaseListItemHelpers.rootSizeNative}
  `,
    RootWeb: css `
    list-style: none;
    ${CFBaseListItemHelpers.rootSizeWeb}
    ${CFBaseListItemHelpers.rootInteractionsWeb}
  `,
    RootWrapper: css `
    box-sizing: border-box;
    padding: ${CFTokens.SPACER.D}px;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${CFTokens.SPACER.D}px;
    align-items: center;
    justify-content: flex-start;
  `,
    RootWrapperNative: css `
    ${CFBaseListItemHelpers.rootInteractionsNative}
  `,
    TextWrapper: css `
    padding: 0;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
    justify-content: flex-start;
  `,
};
